<template>
    <div>
        <div class="clock-outer">
        <div class="clock-inner">
            <img :src="this.asset('img/svg/Clock_numbers.svg')" alt="">
            <div class="mins-box">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="clock-hands-box">
            <span ref="hourHand" class="hour-hand" :style="{ transform: 'rotate(' + hoursHandRotation + 'deg)' }"></span>
            <span ref="minHand" class="min-hand" :style="{ transform: 'rotate(' + minutesHandRotation + 'deg)' }"></span>
            <span ref="secHand" class="sec-hand" :style="{ transform: 'rotate(' + secondsHandRotation + 'deg)' }"></span>
            </div>
            <div class="center-dot"></div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        secHandPosDeg: 360/60,
        minHandPosDeg: 360/60,
        hourHandPosDeg: 360/12,

        interval: null,
        now: new Date(),
    }),
    mounted() {
        this.startMoving();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    computed: {
        hoursHandRotation() {
            return (this.hourHandPosDeg * (this.now.getHours() + (this.now.getMinutes() + this.now.getSeconds()/60) / 60 ));
        },
        minutesHandRotation() {
           return this.minHandPosDeg * this.now.getMinutes(); 
        },
        secondsHandRotation() {
           return this.secHandPosDeg * this.now.getSeconds(); 
        },
    },
    methods: {
        startMoving(){
            this.interval = setInterval(() => {
                // request animation frame and trigger fake-resize event after
                // changing the current timestamp thus chrome redraws the clock
                requestAnimationFrame(() => {
                    this.now = new Date();
                    var evt = document.createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, window, 0);
                    window.dispatchEvent(evt); 
                })
            },1000);
        },
    }
}
</script>